/* eslint-disable jsx-a11y/alt-text */
import React from 'react';

import { Row, Col } from 'antd';
import {
    Box,
    Button,
    Card,
    CardContent,
    CardMedia,
    Container,
    Grid,
    List,
    ListItem,
    ListItemAvatar,
    ListItemText,
    Paper,
    Stack,
    Typography,
} from '@mui/material';
import { styled } from '@mui/system';
import { animated, useSpring } from 'react-spring';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import logo from '../../assets/logo/C.png';
import controle from '../../assets/images/scanner1.png';
import guichet from '../../assets/images/guichet.png';
import payway from '../../assets/images/payway.png';
import dashbord from '../../assets/images/affiliate_preview1.png';
import communicate from '../../assets/images/communiquez_sans_limite.png';
import engage from '../../assets/images/engage_your_community1.png';
import Iconify from '../Iconify';
import DashFeaure from './dash';
import CustomButton from '../CustomButton';
import LucideIcon from '../LucideIcon';

const ContainerAnim = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    color: 'black',
    paddingBottom: 40
});

const Line = styled('div')({
    display: 'flex',
    overflow: 'hidden',
});

const AnimatedBox = styled(animated.div)({
    margin: '10px',
    padding: 15,
    border: '1px solid #ccc',
    backgroundColor: 'white',
    borderRadius: '5px',
    width: 300,
    alignContent: 'center',
    textAlign: 'center',
});
const items = [
    { label: "Concerts", icon: "Music4" },
    { label: "Formations", icon: "GraduationCap" },
    { label: "Sports", icon: "Dumbbell" },
    { label: "Festivals", icon: "Star" },
    { label: "Galas & Soirées", icon: "PartyPopper" },
    { label: "Expositions", icon: "VectorSquare" },
    { label: "Conférences", icon: "Users" },
    { label: "Forums", icon: "MicVocal" },
];

function Services() {

    return (
        <div id="feature" className="block featureBlock">
            <Container maxWidth="xl">
                <Stack spacing={4} >
                    <Stack paddingX={{ xs: 0, sm: 10, md: 20, lg: 30, xl: 40 }}>
                        <Typography textAlign="center" variant="h5" sx={{ color: 'orangered', }}>
                            Types d'événements
                        </Typography>
                        <Typography textAlign="center" variant="h2">
                            La solution parfaite pour <span style={{ color: '#5E17EB' }}>chaque événement</span>
                        </Typography>
                        <Typography textAlign="center" color="text.secondary" fontSize={20}>
                            Que vous organisiez un concert, une conférence ou un gala, Choptonticket s'adapte à tous vos besoins.
                        </Typography>
                    </Stack>

                    <Box px={{ xs: 2, sm: 4 }}><Grid container spacing={3} justifyContent="center">
                        {items.map((item, index) => (
                            <Grid item xs={6} sm={3} key={index}>
                                <Card
                                    sx={{
                                        width: "100%",
                                        height: "100%",
                                        p: 4,
                                        border: "1px solid #f2f2f2",
                                        borderRadius: "10px",
                                    }}
                                >
                                    <Stack
                                        spacing={1.5}
                                        alignItems="center"
                                        justifyContent="center"
                                        textAlign="center"
                                    >
                                        <Box
                                            sx={{
                                                borderRadius: "10px",
                                                bgcolor: "#f3effb",
                                                p: 1,
                                            }}
                                        >
                                            <LucideIcon
                                                name={item.icon}
                                                strokeWidth={2}
                                                size={40}
                                                color="#5E17EB"
                                            />
                                        </Box>

                                        <Typography
                                            sx={{
                                                fontSize: { xs: 15, md: 20 },
                                                fontWeight: 550,
                                            }}
                                        >
                                            {item.label}
                                        </Typography>
                                    </Stack>
                                </Card>
                            </Grid>
                        ))}
                    </Grid></Box>


                </Stack>
            </Container>
        </div>
    );
}

export default Services;
